<template>
  <div>
    <!-- 新增门点弹框  -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="400px"
      :close-on-click-modal="false"
      append-to-body
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Partners.doorName')">
            <el-input v-model="siteInfo.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('Payment.contactPerson')">
            <el-input v-model="siteInfo.contact" no="contact" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Tel')">
            <el-input v-model="siteInfo.phone" no="phone" />
          </el-form-item>
          <div style="display: flex; align-items: flex-start;">
            <cargo-area
              ref="area"
              no="area"
              :country.sync="siteInfo.country"
              :province.sync="siteInfo.province"
              :city.sync="siteInfo.cityNew"
              :district.sync="siteInfo.county"
              :town.sync="siteInfo.town"
              :province-disabled="siteInfo.provinceDisabled || false"
              :city-disabled="siteInfo.cityNewDisabled || false"
              :district-disabled="siteInfo.countyDisabled || false"
              :town-disabled="siteInfo.townDisabled || false"
              :district-label-name="$t('CargoMsg.Cargo_CountyDistrict')"
              :town-label-name="$t('CargoMsg.Cargo_TownStreet')"
              :label-width="'100'"
              :select-width="280"
              :show-town="true"
              style="display: inline-block"
            />

          </div>
          <el-form-item :label="$t('RailwayExport.DetailedAddress')">
            <el-input v-model="siteInfo.address" :disabled="siteInfo.addressDisabled || false" no="address" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button
          v-if="!siteInfo.provinceDisabled && !siteInfo.cityNewDisabled && !siteInfo.countyDisabled && !siteInfo.townDisabled"
          no="aiRecognitionRegion"
          type="primary"
          size="mini"
          style="height: 32px; margin: 4px 0 0 10px;"
          @click="openAiRegionRecognition"
        >{{ $t('CargoMsg.CargoMsg_AIAddressRecognition') }}</el-button>
        <el-button no="save" type="primary" @click="saveSub">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <!-- AI识别弹窗 -->
    <cargo-ai-recognition-dialog
      :visible.sync="aiRecognitionDialog.visible"
      :multimodal="aiRecognitionDialog.multimodal"
      :prompt-key="aiRecognitionDialog.promptKey"
      :call-back="aiRecognitionDialog.callBack"
      :title="$t('CargoMsg.CargoMsg_AIAddressRecognition')"
      :placeholder="aiRecognitionDialog.placeholder"
    />
  </div>
</template>

<script>
import CargoAiRecognitionDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/cargoAiRecognitionDialog.vue'
import { getLoading } from '@/utils/utilBaseElement'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect.vue'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect.vue'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { saveDoorSite } from '@/api/partner/site'
import cargoArea from '@/components/Cargo/Common/cargoArea.vue'
import lang from '@/lang'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'InformationMaintenanceDialog',
  components: {
    cargoArea, CargoAiRecognitionDialog,
    CargoAdvanceSelect,
    cargoUserSelect,
    cargoDepartmentSelect
  },
  props: {
    visible: { type: Boolean, required: true },
    site: { type: Object, required: false, default: null },
    title: { type: String, required: false, default: lang.t('CargoMsg.Cargo_Add') }
  },
  data() {
    return {
      SystemConstants,
      aiRecognitionDialog: {
        multimodal: false, // 多模态模式，true-多模态支持上传文件;false-仅文本上传
        callBack: null,
        promptKey: SystemConstants.REGION_PROMPT_KEY.code,
        visible: false
      },
      siteInfo: {},
      innerVisible: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      this.siteInfo = this.site
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.closeHandler()
      }
      this.init()
      this.$emit('update:visible', newVal)
    }
  },
  async created() {
    if (this.visible) {
      this.siteInfo = this.site
      this.innerVisible = true
      this.init()
    }
  },
  methods: {
    openAiRegionRecognition() {
      this.aiRecognitionDialog.multimodal = false
      this.aiRecognitionDialog.promptKey = SystemConstants.REGION_PROMPT_KEY.code
      this.aiRecognitionDialog.placeholder = this.$t('SeaExport.RecognitionTextTip')
      this.aiRecognitionDialog.callBack = (jsonStr) => this.aiRecognitionRegionPostHandler(jsonStr)
      this.aiRecognitionDialog.visible = true
    },

    async aiRecognitionRegionPostHandler(jsonStr) {
      const parsed = this.safeJsonParse(jsonStr)
      const region = Array.isArray(parsed) ? parsed[0] : parsed
      if (!region) {
        return
      }

      const provinceName = region.province
      const cityName = region.city
      const districtName = region.district
      const streetName = region.street
      const detailAddress = region.detail || region.detailAddress || region.addressDetail || region.address
      const name = region.name
      if (name) {
        this.siteInfo.contact = String(name).trim()
      }

      const phone = region.phone
      if (phone) {
        this.siteInfo.phone = String(phone).trim()
      }

      if (detailAddress) {
        this.siteInfo.address = String(detailAddress).trim()
      }

      if (provinceName || cityName || districtName || streetName) {
        await this.applyRegionByNames({ provinceName, cityName, districtName, streetName })
      }
    },

    safeJsonParse(input) {
      if (!input) {
        return null
      }
      if (typeof input !== 'string') {
        return input
      }
      try {
        return JSON.parse(input)
      } catch (e) {
        return null
      }
    },

    normalizeCnDivisionName(name) {
      return String(name || '')
        .trim()
        .replace(/\s+/g, '')
        .replace(
          /(\u7701|\u5e02|\u533a|\u53bf|\u81ea\u6cbb\u5dde|\u81ea\u6cbb\u53bf|\u81ea\u6cbb\u533a|\u7279\u522b\u884c\u653f\u533a)$/g,
          ''
        )
    },

    normalizeCnTownName(name) {
      return String(name || '')
        .trim()
        .replace(/\s+/g, '')
        .replace(/(街道|镇|乡|苏木|民族乡)$/g, '')
    },

    findDivisionByName(divisionList, name) {
      const normalized = this.normalizeCnDivisionName(name)
      if (!normalized) {
        return null
      }

      const exact = (divisionList || []).find((d) => this.normalizeCnDivisionName(d?.name) === normalized)
      if (exact) {
        return exact
      }

      return (divisionList || []).find((d) => this.normalizeCnDivisionName(d?.name).includes(normalized))
    },

    findTownByName(townList, name) {
      const normalized = this.normalizeCnTownName(name)
      if (!normalized) {
        return null
      }

      const exact = (townList || []).find((t) => this.normalizeCnTownName(t?.name) === normalized)
      if (exact) {
        return exact
      }

      return (townList || []).find((t) => this.normalizeCnTownName(t?.name).includes(normalized))
    },

    async ensureAreaReady() {
      const area = this.$refs.area
      if (!area) {
        return null
      }
      if (Array.isArray(area.provinceList) && area.provinceList.length > 0) {
        return area
      }

      if (typeof area.init === 'function') {
        await area.init('CN')
      }
      return area
    },

    async applyRegionByNames({ provinceName, cityName, districtName, streetName }) {
      const area = await this.ensureAreaReady()
      if (!area) {
        return
      }

      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
      const waitUntil = async(fn, timeoutMs = 2000, intervalMs = 50) => {
        const deadline = Date.now() + timeoutMs
        while (Date.now() < deadline) {
          if (fn()) {
            return true
          }
          await sleep(intervalMs)
        }
        return false
      }

      const province = this.findDivisionByName(area.provinceList, provinceName)
      if (!province?.code) {
        return
      }
      this.siteInfo.province = province.code
      await area.getDivisionByParentCode(province.code, 2)
      await waitUntil(() => Array.isArray(area.cityList) && area.cityList.length > 0)

      const city = this.findDivisionByName(area.cityList, cityName)
      if (!city?.code) {
        return
      }
      this.siteInfo.cityNew = city.code
      await area.getDivisionByParentCode(city.code, 3)
      await waitUntil(() => Array.isArray(area.districtList) && area.districtList.length > 0)

      const district = this.findDivisionByName(area.districtList, districtName)
      if (!district?.code) {
        return
      }
      this.siteInfo.county = district.code

      if (streetName) {
        await area.getDivisionByParentCode(district.code, 4)
        await waitUntil(() => Array.isArray(area.townList) && area.townList.length > 0)
        const town = this.findTownByName(area.townList, streetName)
        if (town?.uuid) {
          this.siteInfo.town = town.uuid
        }
      }
    },

    init() {
      if (this.$refs.area) {
        this.$refs.area.clearCity()
        this.$refs.area.clearDistrict()
        this.$refs.area.clearTown()
        this.$refs.area.init(this.$refs.area.country)
      }
    },
    closeHandler() {
      this.innerVisible = false
    },
    saveSub() {
      const self = this
      const form = self.siteInfo
      for (const key in form) {
        if (typeof form[key] === 'string') {
          form[key] = form[key].trim() // 去掉前后空格
        }
      }
      if (!form.name) {
        self.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('Partners.doorName'))
        return
      }
      form.branchId = this.$store.getters.currentOfficeId
      const loading = getLoading()
      saveDoorSite(form).then(res => {
        if (!res.data) {
          self.$message.error(self.$t('CargoMsg.Cargo_ExistDoorSite'))
        } else {
          self.innerVisible = false
          self.$message.success(self.$t('common.tips.saveSuccess'))
        }
        if (this.site.informationSupplement && this.site.informationSupplement === true) {
          if (this.$refs.area) {
            const area = this.$refs.area
            if (area.$refs.city && area.$refs.city.$refs.advanceSelectRef) {
              form.cityNewStr = area.$refs.city.$refs.advanceSelectRef.query
            }
            if (area.$refs.district && area.$refs.district.$refs.advanceSelectRef) {
              form.countyStr = area.$refs.district.$refs.advanceSelectRef.query
            }
            if (area.$refs.town && area.$refs.town.$refs.advanceSelectRef) {
              form.townStr = area.$refs.town.$refs.advanceSelectRef.query
            }
          }
          this.$emit('syncSiteToJob', form)
        }
        this.$emit('refresh')
      }).catch(() => {
        self.innerVisible = false
      }).finally(() => loading.close())
    }
  }
}
</script>
